const { 
    NERUDA_CARD,
    VANITY_CARD,
    NOT_ALLOWED_NEW_COMPLETE_CREDIT_CARDS_FLOW_COUNTRIES 
  } = require('constants/flagBasedFeatures');
const {
  HORMIGUERO_GDPR_PID,
  NERUDA_GDPR_PID,
  VANITY_GDPR_PID,
  DIAMOND_PACK_GDPR_PID,
  OPEN_DEBIT_GDPR_PID,
  PREMIUM_PACK_GDPR_PID,
  VIRTUAL_CREDIT_PID,
  VIA_T_GDPR_PID
} = require('constants/gdprPlacementIds');
const {
  ADD_NEW_SHIPPING_ADDRESS,
  HIRE_NEW_CREDIT_CARD_FIRST_CODE,
  HIRE_NEW_CREDIT_CARD_SECOND_CODE,
  HIRE_NEW_CREDIT_CARD_THIRD_CODE,
} = require('constants/operationTypes');

const {
  HORMIGUERO_CARD_PRODUCT_ALIAS,
  NERUDA_CARD_PRODUCT_ALIAS,
  NERUDA_CARD_PRODUCT_ALIAS_CC,
  VANITY_CARD_PRODUCT_ALIAS,
  VANITY_CARD_PRODUCT_ALIAS_CC,
  DIAMOND_CARD_PRODUCT_ALIAS,
  DIAMOND_CARD_PRODUCT_ALIAS_CC,
  OPEN_CREDIT_PRODUCT_ALIAS,
  OPEN_CREDIT_PRODUCT_ALIAS_CC,
  VIA_T_CARD_PRODUCT_ALIAS,
  VIA_T_CARD_PRODUCT_ALIAS_CC,
  PREMIUM_PACK_NEW_PRODUCT_ALIAS_CC,
  DIAMOND_CARD_NEW_PRODUCT_ALIAS_CC,
  PREMIUM_PACK_PRODUCT_ALIAS
} = require('constants/hiringProductInformation');

export function getCardData(cardType) {
  const cardDataMap = {
    'open-credit': [{ type: '500', subtype: '801', standard: '0000028' },],
    'viajera': [{ type: '500', subtype: '802', standard: '0000014', }],
    'virtual': [{ type: '500', subtype: '803', standard: '0000001' }],
    'vanity': [{ type: '500', subtype: '805', standard: '0000001', }],
    'via-t': [{ type: '532', subtype: '001', standard: '0000001' }],
    'diamond': [{ type: '501', subtype: '002', standard: '0000001' }],
    'premium': [{ type: '501', subtype: '003', standard: '0000001' }],
  };

  return cardDataMap[cardType];
}

export function navigateBasedOnCardType(cardType, history, immFlagBasedFeatures, immProfile, hasCardOfType) {
  const cardTypeMap = {
    'viajera': () => !immFlagBasedFeatures.get(NERUDA_CARD),
    'vanity': () => !immFlagBasedFeatures.get(VANITY_CARD) || (immProfile.get('isNerudaUser') && hasCardOfType('Neruda')),
    'diamond': () => false,
    'open-credit': () => false,
    'premium': () => false,
    'virtual': () => false,
    'via-t': () => false,
  };

  const shouldRedirect = cardTypeMap[cardType] ? cardTypeMap[cardType]() : true;
  if (shouldRedirect) {
    history.push('/myprofile/global');
  } else if (cardType === 'vanity' && immProfile.get('isNerudaUser') && hasCardOfType('Neruda')) {
    history.push('/myprofile/hire/neruda-landing');
  }
}

export function getPlacementIdCard(cardType) {
  const cardIdMap = {
    'vanity': VANITY_GDPR_PID,
    'hormiguero': HORMIGUERO_GDPR_PID,
    'diamond': DIAMOND_PACK_GDPR_PID,
    'open-credit': OPEN_DEBIT_GDPR_PID,
    'premium': PREMIUM_PACK_GDPR_PID,
    'virtual': VIRTUAL_CREDIT_PID,
    'viajera': NERUDA_GDPR_PID,
    'via-t': VIA_T_GDPR_PID


  };

  return cardIdMap[cardType] || '';
}
export function getServiceCodes(cardType) {
  const commonCodes = [{
    serviceCode: HIRE_NEW_CREDIT_CARD_FIRST_CODE
  }, {
    serviceCode: ADD_NEW_SHIPPING_ADDRESS
  }];
  const adicionalCommonCodes = {
    serviceCode: HIRE_NEW_CREDIT_CARD_SECOND_CODE
  };
  const specialCommonCodes = [{
    serviceCode: HIRE_NEW_CREDIT_CARD_THIRD_CODE
  }, {
    serviceCode: ADD_NEW_SHIPPING_ADDRESS
  }];
  const operationParams = {
    'hormiguero': commonCodes,
    'vanity': commonCodes,
    'viajera': commonCodes,
    'open-credit': commonCodes,
    'diamond': [
      ...commonCodes,
      adicionalCommonCodes
    ],
    'premium': [
      ...commonCodes,
      adicionalCommonCodes
    ],
    'via-t': specialCommonCodes,
    'virtual': [{ serviceCode: HIRE_NEW_CREDIT_CARD_FIRST_CODE }]
  };

  return operationParams[cardType] || [];
}

export function getHireCmsKey(cardType) {
  const cardTypeAliasMap = {
    'hormiguero': {
      hireCmsKey: HORMIGUERO_CARD_PRODUCT_ALIAS,
      collectiveLocation: '',
      contractPdfData: 'nrd_opencredit'
    },
    'vanity': {
      hireCmsKey: __CONTACT_CENTER__ ? VANITY_CARD_PRODUCT_ALIAS_CC : VANITY_CARD_PRODUCT_ALIAS,
      collectiveLocation: '',
      contractPdfData: 'nrd_opencredit'
    },
    'viajera': {
      hireCmsKey: __CONTACT_CENTER__ ? NERUDA_CARD_PRODUCT_ALIAS_CC : NERUDA_CARD_PRODUCT_ALIAS,
      collectiveLocation: '',
      contractPdfData: 'nrd_opencredit'
    },
    'open-credit': {
      hireCmsKey: __CONTACT_CENTER__ ? OPEN_CREDIT_PRODUCT_ALIAS_CC : OPEN_CREDIT_PRODUCT_ALIAS,
      collectiveLocation: '',
      contractPdfData: 'open_credit'
    },
    'diamond': {
      hireCmsKey: __CONTACT_CENTER__ ? DIAMOND_CARD_NEW_PRODUCT_ALIAS_CC : DIAMOND_CARD_PRODUCT_ALIAS,
      collectiveLocation: __CONTACT_CENTER__ 
                            ? 'Contrataciones_Paso_default_diamondpack_cc_1' 
                            : 'Contrataciones_Paso_default_diamondpack_1',
      contractPdfData: 'diamond_pack_card'
    },
    'premium': {
      hireCmsKey: __CONTACT_CENTER__ ? PREMIUM_PACK_NEW_PRODUCT_ALIAS_CC : PREMIUM_PACK_PRODUCT_ALIAS,
      collectiveLocation: __CONTACT_CENTER__ 
                            ? 'Contrataciones_Paso_default_premiumpack_cc_1' 
                            : 'Contrataciones_Paso_default_premiumpack_1',
      contractPdfData: 'premium_pack_card'
    },
    'via-t': {
      hireCmsKey: __CONTACT_CENTER__ ? VIA_T_CARD_PRODUCT_ALIAS_CC : VIA_T_CARD_PRODUCT_ALIAS,
      collectiveLocation: '',
      contractPdfData: 'via_t'
    },
  };

  return cardTypeAliasMap[cardType] || [];
}